<div
  class="toolbar"
  role="complementary"
  aria-label="Angular Scan DevTools"
>
  <div
    class="toolbar__header"
    data-toolbar-drag-handle
    title="Drag to move panel"
  >
    <span class="toolbar__logo" aria-hidden="true">◉</span>
    <span class="toolbar__title">angular-scan</span>

    <button
      class="toolbar__btn"
      type="button"
      data-toolbar-action="toggle-enabled"
      [attr.aria-pressed]="enabled()"
      [title]="scanningPausedTitle()"
    >{{ scanningToggleIcon() }}</button>

    <button
      class="toolbar__btn"
      type="button"
      data-toolbar-action="toggle-settings"
      [attr.aria-pressed]="settingsOpen()"
      title="Settings"
    >⚙</button>

    <button
      class="toolbar__btn"
      type="button"
      data-toolbar-action="toggle-expanded"
      [attr.aria-pressed]="expanded()"
      [title]="expandInspectorTitle()"
    >{{ expandInspectorIcon() }}</button>
  </div>

  <div class="toolbar__stats">
    <span class="toolbar__stat" title="Total change detection checks">
      <span class="toolbar__stat-label">checks</span>
      <strong class="toolbar__stat-value">{{ tracker.totalRenders() }}</strong>
    </span>
    <span
      class="toolbar__stat"
      [class.toolbar__stat--warn]="showWastedWarning()"
      title="Unnecessary renders: component was checked but DOM did not change"
    >
      <span class="toolbar__stat-label">wasted</span>
      <strong class="toolbar__stat-value">{{ tracker.totalUnnecessary() }}</strong>
    </span>
  </div>

  @if (settingsOpen()) {
    <div class="toolbar__settings" role="group" aria-label="Scan settings">
      @for (toggle of settingToggles; track toggle.key) {
        <angular-scan-toolbar-setting
          [label]="toggle.label"
          [configKey]="toggle.key"
        />
      }

      <label class="toolbar__setting toolbar__setting--column">
        <span class="toolbar__setting-label">
          Flash duration
          <span class="toolbar__setting-value">{{ flashDurationText() }}</span>
        </span>
        <input
          class="toolbar__slider"
          type="range"
          min="100"
          max="2000"
          step="100"
          data-toolbar-input="flash-duration"
          [value]="flashDurationMs()"
          aria-label="Flash duration in milliseconds"
        />
      </label>

      <button
        class="toolbar__reset"
        type="button"
        data-toolbar-action="reset-stats"
        title="Clear all render stats"
      >↺ Reset stats</button>
    </div>
  }

  @if (expanded()) {
    <div
      class="toolbar__inspector"
      role="list"
      aria-label="Component render counts"
    >
      @for (comp of tracker.trackedComponents(); track comp.hostElement) {
        <div
          class="toolbar__component"
          role="listitem"
          [class.toolbar__component--warn]="comp.lastRenderKind === 'unnecessary'"
          [title]="comp.componentName + ' — ' + comp.totalRenders + ' checks, ' + comp.unnecessaryRenders + ' wasted'"
        >
          <span class="toolbar__component-name">{{ comp.componentName }}</span>
          <span class="toolbar__component-count">{{ comp.totalRenders }}</span>
          @if (comp.unnecessaryRenders > 0) {
            <span class="toolbar__component-wasted" aria-label="wasted renders">
              {{ comp.unnecessaryRenders }}W
            </span>
          }
        </div>
      }
    </div>
  }
</div>
